/**
 * Grievance issue tags — shared across the customer app grievance form
 * and the staff CRM Tickets filter (Iter 118).
 */
export const ISSUE_TAGS = [
  "Need collection",
  "Need bill",
  "No pickup until further notice",
  "Emergency collection required",
  "Collection scheduled next week",
  "Bag delivery pending",
  "Complaint about staff",
];
